export default "__VITE_ASSET__BNtIQV_Z__"